<template>
    <div class="relative border border-gray-400 rounded-xl h-84 w-100 bg-white">
        <div class="absolute -top-10 left-40 p-3.5 h-20 w-20 mx-auto bg-primary-800 rounded-full">
            <Icon class="w-full h-full" :src="IconSource.Login"></Icon>
        </div>

        <div class="flex h-full w-full px-4">
            <form class="pt-20 pb-4 w-full flex flex-col" @submit.prevent="onSubmit">
                <div>
                    <CustomInput v-model:value="form.email" hide-auth-state :show-required-indication="false" :label="$t('views.auth.login.emailFieldLabel')" input-type="email" @submit="onSubmit"></CustomInput>
                    <CustomInput
                        v-model:value="form.password"
                        hide-auth-state
                        :show-required-indication="false"
                        :label="$t('views.auth.login.passwordFieldLabel')"
                        input-type="password"
                        @submit="onSubmit"
                    ></CustomInput>
                </div>

                <div class="flex justify-between text-gray-500">
                    <CustomCheckbox v-model:checked="form.remember" label-class="text-gray-500" tabbable :label="$t('views.auth.login.rememberMeCheckboxLabel')"></CustomCheckbox>
                    <router-link class="italic leading-4" to="/auth/forgot">{{ $t('views.auth.login.forgotPasswordLinkLabel') }}</router-link>
                </div>

                <div class="mt-auto w-full">
                    <CustomButton :disabled="disableButtons" @click="onSubmit">
                        {{ $t('views.auth.login.submitButtonLabel') }}
                    </CustomButton>
                </div>
            </form>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Form } from '@makeabledk/vue-ui/support/http';
import CustomInput from '@/components/ui/CustomInput.vue';
import CustomCheckbox from '@/components/ui/CustomCheckbox.vue';
import CustomButton from '@/components/ui/CustomButton.vue';

export default defineComponent({
    components: { CustomInput, CustomCheckbox, CustomButton },
    data() {
        return {
            form: new Form({
                email: '',
                password: '',
                remember: true,
            }),
            disableButtons: false,
        };
    },
    methods: {
        onSubmit() {
            this.disableButtons = true;
            alert('Not yet implemented');
            this.disableButtons = false;
        },
    },
});
</script>
